import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { all_routes } from "../router/all_routes";
import { Mail, PhoneCall, Send } from "react-feather";

const Footer = () => {
  const route = all_routes;

  return (
    <>
      {/* Footer Modern */}
      <footer className="footer footer-modern">
        <div className="footer-content-modern">
          <div className="container">
            <div className="row">
              {/* Company Info */}
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="footer-widget-modern">
                  <div className="footer-logo-modern mb-4">
                    <ImageWithBasePath
                      src="assets/img/logo.png"
                      className="img-fluid"
                      style={{ maxHeight: '50px', width: 'auto' }}
                      alt="Logo"
                    />
                    <h4 className="mt-3">AD SHOWROOM</h4>
                  </div>
                  <p className="footer-desc-modern">
                    Showroom premium de automobile verificate. Transparență totală, expertiză profesională și pasiune pentru mașini de calitate.
                  </p>
                  <div className="footer-social-modern">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                      <i className="fab fa-instagram" />
                    </a>
                    <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                      <i className="fab fa-tiktok" />
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-lg-2 col-md-6 mb-4">
                <div className="footer-widget-modern">
                  <h5 className="footer-title-modern">Navigare</h5>
                  <ul className="footer-links-modern">
                    <li><Link to={route.home}>Acasă</Link></li>
                    <li><Link to={route.listinggrid}>Showroom</Link></li>
                    <li><Link to={route.aboutus}>Despre Noi</Link></li>
                    <li><Link to={route.contact}>Contact</Link></li>
                  </ul>
                </div>
              </div>

              {/* Legal */}
              <div className="col-lg-2 col-md-6 mb-4">
                <div className="footer-widget-modern">
                  <h5 className="footer-title-modern">Informații Legale</h5>
                  <ul className="footer-links-modern">
                    <li><Link to={route.termsconditions}>Termeni și Condiții</Link></li>
                    <li><Link to={route.privacypolicy}>Politica de Confidențialitate</Link></li>
                    <li><Link to={route.cookies}>Politica Cookies</Link></li>
                    <li><Link to={route.gdpr}>GDPR</Link></li>
                  </ul>
                </div>
              </div>

              {/* Contact */}
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="footer-widget-modern">
                  <h5 className="footer-title-modern">Contact</h5>
                  <ul className="footer-contact-modern">
                    <li>
                      <i className="feather-phone" />
                      <a href="tel:+40774555555">+40 774 555 555</a>
                    </li>
                    <li>
                      <i className="feather-mail" />
                      <a href="mailto:adcarshowroom@gmail.com">adcarshowroom@gmail.com</a>
                    </li>
                    <li>
                      <i className="feather-map-pin" />
                      <span>București, România</span>
                    </li>
                  </ul>
                  <div className="footer-hours-modern mt-3">
                    <p><strong>Program:</strong></p>
                    <p>Luni - Vineri: 09:00 - 18:00</p>
                    <p>Sâmbătă: 10:00 - 14:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Romanian Compliance Section */}
        <div className="footer-compliance-modern">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="compliance-logos">
                  <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer" className="compliance-logo">
                    <div className="anpc-placeholder">ANPC</div>
                  </a>
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="compliance-logo">
                    <div className="sal-placeholder">SAL</div>
                  </a>
                </div>
                <p className="compliance-text">
                  Conform Legii 363/2007, în cazul unui litigiu, consumatorul poate apela la entitatea de soluționare alternativă a litigiilor (ANPC) sau poate folosi platforma SOL.
                </p>
              </div>
              <div className="col-lg-4 text-lg-end">
                <div className="compliance-links">
                  <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer">ANPC - Protecția Consumatorilor</a>
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">SOL - Soluționare Online Litigii</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom-modern">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <p className="copyright-modern">
                  © 2025 AD SHOWROOM. Toate drepturile rezervate.
                </p>
              </div>
              <div className="col-md-6 text-md-end">
                <p className="legal-info-modern">
                  CUI: RO12345678 | J40/1234/2025
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* /Footer Modern */}
    </>
  );
};

export default Footer;
